import { FiArrowLeftCircle, FiPlay } from 'react-icons/fi';
import { IoEyeOutline, IoGameControllerOutline } from 'react-icons/io5';
import { LuCircleDollarSign } from 'react-icons/lu';
import { FaRegCaretSquareRight, FaUserTie } from 'react-icons/fa';
import { CiUser } from 'react-icons/ci';
import { FaBangladeshiTakaSign, FaRegEyeSlash } from 'react-icons/fa6';
import { IoChevronBackCircleOutline } from 'react-icons/io5';
import { TbFileTypeDocx } from 'react-icons/tb';
import { PiFilePdfBold } from 'react-icons/pi';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import { TbRefresh } from 'react-icons/tb';
import { TbFileTypeCsv } from 'react-icons/tb';
import { IoIosArrowDown } from 'react-icons/io';
import { AiFillPushpin } from 'react-icons/ai';
export const reactIcons = {
  circleArrow: FiArrowLeftCircle,
  play: FiPlay,
  user: FaUserTie,
  eye: IoEyeOutline,
  eyeof: FaRegEyeSlash,
  game: IoGameControllerOutline,
  casino: LuCircleDollarSign,
  squareBack: FaRegCaretSquareRight,
  user2: CiUser,
  taka: FaBangladeshiTakaSign,
  circleBack: IoChevronBackCircleOutline,
  doc: TbFileTypeDocx,
  pdf: PiFilePdfBold,
  excel: PiMicrosoftExcelLogoFill,
  refresh: TbRefresh,
  csv: TbFileTypeCsv,
  downarrow: IoIosArrowDown,
  pin: AiFillPushpin,
} as const;
